export default __webpack_public_path__ + "static/media/B2_22.69e9f3bf.mp3";